import { useState } from "react";
import { Abas, Aviso, PainelDaAba } from "../componentes/ui";
import { PainelDaQuarentena } from "../componentes/canais/PainelDaQuarentena";
import { PainelDeCaixas } from "../componentes/canais/PainelDeCaixas";
import { PainelDeDistribuicao } from "../componentes/canais/PainelDeDistribuicao";
import { PainelDeDominios } from "../componentes/canais/PainelDeDominios";
import { PainelDeEmailsRecebidos } from "../componentes/canais/PainelDeEmailsRecebidos";
import { PainelDeFormularios } from "../componentes/canais/PainelDeFormularios";
import { podeNaSessao, useSessao } from "../nucleo/sessao";
import { useTitulo } from "../nucleo/titulo";

type Aba = "quarentena" | "emails" | "caixas" | "dominios" | "formularios" | "distribuicao";

const ABAS_DA_TRIAGEM = [
  { chave: "quarentena", rotulo: "Quarentena" },
  { chave: "emails", rotulo: "E-mails recebidos" },
] as const;
const ABAS_DA_ADMINISTRACAO = [
  { chave: "caixas", rotulo: "Caixas de e-mail" },
  { chave: "dominios", rotulo: "Domínios" },
  { chave: "formularios", rotulo: "Formulários públicos" },
  { chave: "distribuicao", rotulo: "Distribuição" },
] as const;

/** Por onde os pedidos chegam ao atendimento: e-mail, formulário público e a divisão entre a equipe. */
export function Canais() {
  useTitulo("Canais de entrada");
  const sessao = useSessao();
  const [ativa, setAtiva] = useState<Aba | null>(null);

  if (!sessao.data) {
    return (
      <p className="lead" role="status">
        Verificando o seu acesso…
      </p>
    );
  }

  const administra = podeNaSessao(sessao.data, "canal:gerenciar");
  const triagem = podeNaSessao(sessao.data, "canal:triagem");
  if (!administra && !triagem) {
    return (
      <Aviso tom="marca" data-testid="canais-sem-permissao">
        Os canais de entrada do atendimento são mantidos pela administração do portal.
      </Aviso>
    );
  }

  const abas = [...(triagem ? ABAS_DA_TRIAGEM : []), ...(administra ? ABAS_DA_ADMINISTRACAO : [])];
  const aba = ativa ?? abas[0]!.chave;

  return (
    <div data-testid="canais">
      <h1 className="titulo-pagina">Canais de entrada</h1>
      <p className="lead mb-4">
        {administra
          ? "Caixas de e-mail, formulários públicos de abertura e a divisão automática dos chamados entre a equipe."
          : "O que chegou por e-mail e ficou esperando uma decisão da equipe."}
      </p>
      <Abas rotulo="Canais" id="canais" itens={abas} ativa={aba} aoSelecionar={setAtiva} className="mb-4" />
      {triagem ? (
        <>
          <PainelDaAba id="canais" chave="quarentena" ativa={aba} data-testid="painel-quarentena"><PainelDaQuarentena /></PainelDaAba>
          <PainelDaAba id="canais" chave="emails" ativa={aba} data-testid="painel-emails"><PainelDeEmailsRecebidos /></PainelDaAba>
        </>
      ) : null}
      {administra ? (
        <>
          <PainelDaAba id="canais" chave="caixas" ativa={aba} data-testid="painel-caixas"><PainelDeCaixas /></PainelDaAba>
          <PainelDaAba id="canais" chave="dominios" ativa={aba} data-testid="painel-dominios"><PainelDeDominios /></PainelDaAba>
          <PainelDaAba id="canais" chave="formularios" ativa={aba} data-testid="painel-formularios"><PainelDeFormularios /></PainelDaAba>
          <PainelDaAba id="canais" chave="distribuicao" ativa={aba} data-testid="painel-distribuicao"><PainelDeDistribuicao /></PainelDaAba>
        </>
      ) : null}
    </div>
  );
}
